import styled from 'styled-components'

export const Wrapper = styled.div`
  flex: 1 0;
  flex-direction: column;
`
